import {z} from "zod/v4-mini"
import {MaterialConnection} from "#material/nodes/base/connection/material-connection"

// TODO: verify return type
export const materialConnectionSchema = (_schema: z.ZodMiniType = z.unknown()): z.ZodMiniType<MaterialConnection<unknown>> => z.instanceof(MaterialConnection)
